import { createContext, Dispatch, SetStateAction } from 'react';

import { CompanyUserProfile } from './types/CompanyUserProfile';

interface CompanyAuthContextType {
  profile: CompanyUserProfile | undefined;
  setProfile: Dispatch<SetStateAction<CompanyUserProfile | undefined>>;
}

export const CompanyAuthContext = createContext<CompanyAuthContextType | undefined>(undefined);
